module.exports = __webpack_public_path__ + "static/media/admin.88bfa4f6.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/objects/admin.svg
// module id = 1088
// module chunks = 36